import {useState } from "react";
import { Title, Body } from "@vds/typography";
import {
  Accordion,
  AccordionDetail,
  AccordionHeader,
  AccordionItem,
  AccordionSubTitle,
  AccordionTitle,
} from "@vds/accordions";
import { Notification } from "@vds/notifications";
import { useDispatch, useSelector } from "react-redux";
import { getCvAppCategory, getcvAppName } from "../../../global/utility/cvAppUtils";
import {
  CVAPP_CAMERAADJUSTMENT,
  CVAPP_OBJECTBLUR,
  CVAPP_PERSON_DETECTION,
  CVAPP_VEHICLE_DETECTION,
} from "../../../global/constants/cvappConstants";
import { adjustPolygonPoints } from "../../../utils";
import { transformPolygonData } from "../../../global/utility/roiUtils";
import { useNavigate } from "react-router-dom";
import { resetRoi, showNotificationBanner } from "../../../store/actions";
import { ACTIVITY_LOG_CONSTANTS } from "../../../global/constants/constants";
import { getActiveLicenseSku } from "../../../global/constants/licensesConstants";

const ActivityLogContainerComponent = ({
  eventStatus,
  resolveDescription,
  description,
  activityDateTime,
  resolvedNote1,
  resolvedNote2,
  videoDownloaded,
  title,
  stateData,
  dateTime,
  innerStyle,
  findTimeDurationOfEvidence,
  downloadDay,
  cvappName,
  cvappid,
  fovObject,
  cameraData,
  companionObject,
  roiId,
  tagids,
  deployments,
  incidentId,
  }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const sitetagList = useSelector((state) => state.sitesReducer.siteTagList);
  const roiList = useSelector((state) => state.deviceReducer.roiList) || [];
  const appName = getcvAppName(cvAppList, cvappid);
  const cvAppCategory = getCvAppCategory(cvAppList, cvappid);
  const cvAppName = cvappName ? cvappName : appName;
      const maxX = stateData?.polygon?.frame?.maxX
      ? stateData?.polygon?.frame?.maxX
      : stateData?.polygon?.polygon?.frame?.maxX ??
        stateData?.polygon?.polygon?.frame?.maxX;
    const maxY = stateData?.polygon?.frame?.maxY
      ? stateData?.polygon?.frame?.maxY
      : stateData?.polygon?.polygon?.frame?.maxY ??
        stateData?.polygon?.polygon?.frame?.maxY;
      const polygonPoints = transformPolygonData(stateData);
  const roiObject = roiList && roiList.find((roi) => roi?.id === roiId);
  const roiDetails ={
    FOVId: fovObject?.id,
    cameraId: cameraData?.id,
    companionId: companionObject?.id,
    cvappid: cvappid,
    id: roiId,
    category: cvAppCategory,
    deployments: deployments[0] ? [deployments[0]] : [],
    polygon: stateData?.polygon,
    roiName: roiObject?.name,
  }
  const [roiData, setRoiData] = useState([{
          groupName: fovObject?.name,
          cvAppName: cvappName,
          points: adjustPolygonPoints([maxX, maxY], polygonPoints, [832, 532]),
          originalPoints:
          polygonPoints && polygonPoints.length >= 3 ? polygonPoints : [],
          roiId: roiId,
          frame: roiDetails,
          name: roiObject?.name,
          cvappid: cvappid,
          category: cvAppCategory,
          deployments: deployments,
          fovObj: roiDetails,
          selectedCameraQR: cameraData?.id,
          companionSelected: companionObject?.id,
        }]);

      var tagObject = [];
      if (
        cvappName != CVAPP_OBJECTBLUR ||
        cvappName != CVAPP_CAMERAADJUSTMENT
      ) {
        (Array.isArray(tagids) ? tagids : []).forEach((tag) => {
          tagObject = [
            ...tagObject,
            ...(Array.isArray(sitetagList?.floors) ? sitetagList.floors : []).filter((f) => {
             return f.id === tag; 
            }),
          ];
          tagObject = [
            ...tagObject,
            ...(Array.isArray(sitetagList?.areas) ? sitetagList.areas : []).filter((f) => {
              return f.id === tag;
            }),
          ];
          tagObject = [
            ...tagObject,
            ...(Array.isArray(sitetagList?.subareas) ? sitetagList.subareas : []).filter((f) => {
              return f.id === tag;
            }),
          ];
        });
      }
  const tagNames = tagObject.map((m) => {return m?.name});
  const [selectedRoi, setSelectedRoi] = useState({
      title: fovObject?.name,
      value: appName,
      cvappid: cvappid,
      roiId: roiId,
      category: cvAppCategory,
      tagids: tagids,
      sitenames: tagNames,
      groupName: "ROI1-" + fovObject?.name + "-" + appName,
      deployments: deployments,
    });

        const selectedState = {
        cvapps: [selectedRoi],
        roiUpdateData: roiData,
        FOVId: fovObject?.id,
        cameraId: cameraData?.id,
        companionId: companionObject?.id,
        action: ACTIVITY_LOG_CONSTANTS.ACTION_UPDATE,
        cameraData: cameraData,
        streamData: [fovObject],
        FOVSnapshot: fovObject?.customdata?.imageid,
        fieldOfViews: fovObject?.name,
        FOVName: fovObject?.name,
        location: ACTIVITY_LOG_CONSTANTS.LOCATION_EVENTS_INFO,
        cameraname: cameraData?.name,
        cvappid: cvappid,
        tagids: tagids,
        deployParameters:
          selectedRoi?.deployments[0]?.config?.["deploy-parameters"],
        deploymentId:
          selectedRoi?.deployments[0]?.id,
        sku: getActiveLicenseSku(fovObject?.licenses),
        roiList: roiData,
        siteSelected: cameraData?.siteids,
        originPage: ACTIVITY_LOG_CONSTANTS.ORIGIN_PAGE_EVENTS_INFO,
        eventId: incidentId,
      };
  const shouldShowNotification =
    (cvAppName && cvAppName === CVAPP_VEHICLE_DETECTION) ||
    (cvAppName && cvAppName === CVAPP_PERSON_DETECTION);

  const handleEditRegionClick = () => {
     if(cameraData && fovObject && roiObject){
      dispatch(resetRoi());
      navigate("/polygon", { state: selectedState })
      }else{
        dispatch(
          showNotificationBanner({
            type: ACTIVITY_LOG_CONSTANTS.ROI_EDIT_FAIL_TYPE,
            priority: ACTIVITY_LOG_CONSTANTS.PRIORITY_CRITICAL,
            showNotification: true,
          })
        );
     }
  };
  return (
    <>
      {shouldShowNotification && (
        <div className="notification_container">
          <Notification
            type="info"
            title={ACTIVITY_LOG_CONSTANTS.COLOR_SELECTION_ACCURACY_TITLE}
            subtitle={ACTIVITY_LOG_CONSTANTS.COLOR_SELECTION_ACCURACY_SUBTITLE}
            surface="light"
            fullBleed={false}
            inline={false}
            disableFocus={true}
            hideCloseButton={true}
            buttonData={[
              {
                children: ACTIVITY_LOG_CONSTANTS.EDIT_APPLICATION_SETTINGS_BUTTON,
                onClick: handleEditRegionClick,
              },
            ]}
            layout="vertical"
          />
        </div>
      )}

      <div style={{ ...innerStyle }}>
        <Title bold size="small">
          Activity log
        </Title>
      </div>
      <>
        <Accordion bottomLine={true}>
          {eventStatus === "Resolved" && (
            <AccordionItem>
              <AccordionHeader trigger={{ type: "icon" }}>
                <AccordionTitle>
                  <Body size="large">
                    {resolveDescription ? resolveDescription : description}
                  </Body>
                </AccordionTitle>
                <AccordionSubTitle>
                  <Body size="small">{activityDateTime}</Body>
                </AccordionSubTitle>
              </AccordionHeader>
              <AccordionDetail>
                {resolvedNote1 !== "" ? resolvedNote1 : resolvedNote2}
              </AccordionDetail>
            </AccordionItem>
          )}

          {Array.isArray(videoDownloaded) && videoDownloaded.map((video, index) => (
            <AccordionItem key={index}>
              <AccordionTitle>
                <div className="event_time_text">
                  <Body size="large">{video?.description}</Body>
                  <Body size="small" color="#6F7171">
                    {downloadDay ? downloadDay(video?.downloadTime) : ""}
                  </Body>
                </div>
              </AccordionTitle>
            </AccordionItem>
          ))}
          <Accordion bottomLine={true}>
            <AccordionItem>
              <AccordionTitle>
                <div className="event_time">
                  <Body size="large">
                    {title
                      ? title
                      : stateData?.evidence?.id?.length > 0 &&
                        findTimeDurationOfEvidence
                      ? findTimeDurationOfEvidence()
                      : stateData?.description}
                  </Body>
                  <Body size="small" color="#6F7171">
                    {dateTime}
                  </Body>
                </div>
              </AccordionTitle>
            </AccordionItem>
          </Accordion>
        </Accordion>
      </>
    </>
  );
};

export default ActivityLogContainerComponent;
